import React, { useEffect, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { UtilisateursJsonldUserworkgroupRead } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import {
    UtilisateurApiObject,
    UtilisateursGroupesTravailWithGroupLib,
} from '@europrocurement/l2d-domain';
import { SearchBar } from '../../atoms';
import { UtilisateurChoiceItem } from '../UtilisateurChoiceItem/UtilisateurChoiceItem';

export type UtilisateurSearchListProps = {
    users:
        | UtilisateursJsonldUserworkgroupRead[]
        | UtilisateurApiObject[]
        | UtilisateursGroupesTravailWithGroupLib[];
    selectedUser?: UtilisateursJsonldUserworkgroupRead | UtilisateurApiObject | null;
    setSelectedUser?: React.Dispatch<
        React.SetStateAction<UtilisateursJsonldUserworkgroupRead | UtilisateurApiObject | null>
    >;
    extraSearchBarButton?: JSX.Element;
    listTitle?: string;
    userInfo?: (
        user:
            | UtilisateursGroupesTravailWithGroupLib
            | UtilisateurApiObject
            | UtilisateursJsonldUserworkgroupRead,
    ) => string;
};
export const UtilisateurSearchList: React.FunctionComponent<UtilisateurSearchListProps> =
    function ({ users, selectedUser, setSelectedUser, extraSearchBarButton, listTitle, userInfo }) {
        const { palette } = useTheme();
        const [searchBarValue, setSearchBarValue] = useState('');
        const [usersFiltered, setuserFiltered] = useState<UtilisateursJsonldUserworkgroupRead[]>(
            [],
        );

        useEffect(() => {
            // Filter user array by the search bar value
            const searchValue = searchBarValue.trim().toUpperCase();
            let filterdUsersBySearch = users;
            if (searchValue) {
                filterdUsersBySearch = users.filter(
                    (user) =>
                        user.nom?.toUpperCase().includes(searchValue) ||
                        user.prenom?.toUpperCase().includes(searchValue) ||
                        user.mail?.toUpperCase().includes(searchValue),
                );
            }

            setuserFiltered(filterdUsersBySearch);
        }, [users, searchBarValue]);

        return (
            <>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                    {extraSearchBarButton}
                    <SearchBar
                        placeholder="Rechercher un utilisateur par nom, prénom, mail..."
                        onChange={(e) => {
                            setSearchBarValue(e.target.value);
                        }}
                        value={searchBarValue}
                        sx={{ marginTop: 0 }}
                    />
                </Box>
                {listTitle && (
                    <Typography
                        variant="l2dbodyxs"
                        sx={{ color: 'text.gris70' }}
                    >
                        {listTitle}
                    </Typography>
                )}
                <Box
                    data-testid="applying-members-list-container"
                    sx={{ maxHeight: '200px', overflow: 'auto' }}
                >
                    {usersFiltered.map((user) => (
                        <UtilisateurChoiceItem
                            key={user.id}
                            user={user}
                            setSelectedUser={setSelectedUser}
                            selectedUser={selectedUser}
                            userInfo={userInfo ? userInfo(user) : undefined}
                            sx={{
                                ':hover': {
                                    backgroundColor: palette.grey.A700,
                                },
                            }}
                        />
                    ))}
                </Box>
            </>
        );
    };
